import { InputGroup } from '@/components/ui/chakra/input-group';
import LucideIcon from '@/components/ui/LucideIcon';
import { Input } from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import React, { forwardRef } from 'react';

type HeaderSearchInputProps = {
  inputGroupProps?: ComponentProps<typeof InputGroup>;
} & ComponentProps<typeof Input>;

const HeaderInput = forwardRef<HTMLInputElement, HeaderSearchInputProps>(({ ...props }, ref) => {
  return (
    <InputGroup
      alignItems="center"
      backgroundColor="white"
      borderRadius="4px"
      endElement={<LucideIcon color="neutral.60" height="22px" name="Search" strokeWidth={1} width="22px" />}
      gap={12}
      height="40px"
      paddingX="15px"
      width="100%"
      endElementProps={{
        paddingX: '15px',
      }}
      focusVisibleRing="outside"
    >
      <Input
        ref={ref}
        border="none"
        color="neutral.90"
        fontSize="14px"
        padding={0}
        placeholder="Find your products"
        _focus={{
          outline: 'none',
        }}
        _focusVisible={{
          outline: 'none',
        }}
        _placeholder={{
          color: 'neutral.40',
        }}
        focusVisibleRing="none"
        {...props}
      />
    </InputGroup>
  );
});

export default HeaderInput;
